<script setup>
const props=defineProps({profileId:[String,Number],list:String}),emit=defineEmits(['modal:remove']);
const items=ref([]),page=ref(0),total=ref(0),busy=ref(false),failure=ref('');
const client=useUser(),changing=ref(null);
let alive=true;onBeforeUnmount(()=>{alive=false;});
async function load(){
 if(busy.value)return;busy.value=true;failure.value='';const next=page.value+1;
 try{const data=await $fetch('/api/profiles/'+props.profileId+'/following',{query:{list:props.list,page:next}});if(!alive)return;items.value=[...new Map([...items.value,...data.items].map(p=>[p.id,p])).values()];page.value=next;total.value=data[props.list];}
 catch{if(alive)failure.value='Не удалось загрузить список. Попробуйте ещё раз.';}
 finally{if(alive)busy.value=false;}
}
async function unfollow(person){
 if(changing.value!==null||busy.value)return;
 changing.value=person.id;failure.value='';
 try{
  await $fetch('/api/profiles/follow',{method:'POST',body:{profile_id:person.id,follow:false}});
  if(!alive)return;
  person.is_following=false;
  if(props.list==='following'&&String(client.value?.client_id)===String(props.profileId)){
   items.value=[];page.value=0;await load();
  }
  await refreshNuxtData([...new Set([props.profileId,person.id,client.value?.client_id].filter(Boolean).map(id=>'profile-following:'+id))]);
 }catch{if(alive)failure.value='Не удалось отписаться. Попробуйте ещё раз.';}
 finally{if(alive)changing.value=null;}
}
function open(person){emit('modal:remove');return navigateTo('/profiles/'+person.id);}
onMounted(load);
</script>
<template><div class="uo-follow-list">
 <p v-if="failure" class="uo-alert" role="alert">{{failure}} <button class="uo-text-link" type="button" @click="load">Повторить</button></p>
 <ul v-if="items.length"><li v-for="person in items" :key="person.id"><button class="uo-follow-person" type="button" @click="open(person)"><Userpic class="userpic" :src="'/files/userpic/'+person.id+'.webp'" :name="person.name"/><span><strong>{{person.name||person.nickname}}</strong><small>@{{person.nickname}}</small></span></button><button v-if="person.is_following" type="button" class="uo-btn uo-btn-secondary uo-follow-unsubscribe" :disabled="changing!==null||busy" :aria-label="'Отписаться от '+(person.name||person.nickname)" @click="unfollow(person)">{{changing===person.id?'Сохраняем…':'Отписаться'}}</button></li></ul>
 <p v-if="busy" role="status">Загружаем список…</p>
 <p v-else-if="!failure&&!items.length" class="pc-caption">{{list==='followers'?'Подписчиков пока нет.':'Подписок пока нет.'}}</p>
 <button v-if="items.length<total" class="uo-btn uo-btn-secondary" type="button" :disabled="busy" @click="load">Показать ещё</button>
</div></template>
<style>
.uo-modal-layer:has(.uo-follow-list-modal){align-items:center;padding:var(--uo-spacing-4)}
.uo-modal-layer .uo-modal-panel.uo-follow-list-modal{min-height:0!important;overflow:hidden!important;width:min(480px,100%);max-width:480px!important;max-height:calc(var(--uo-modal-visible-height,100dvh) - 32px);padding:var(--uo-spacing-4);border-radius:var(--uo-radius-panel)}
.uo-follow-list{min-height:0;overflow:auto;display:grid;gap:var(--uo-spacing-3)}
.uo-follow-list ul{list-style:none;margin:0;padding:0}
.uo-follow-list li+li{border-top:1px solid var(--uo-color-border-default)}
.uo-follow-list li{display:flex;align-items:center;gap:var(--uo-spacing-2)}
.uo-follow-list .uo-follow-unsubscribe{flex:none;min-height:44px;padding-inline:var(--uo-spacing-3);font-size:14px}
.uo-follow-list .uo-follow-person{display:flex;align-items:center;text-align:left;gap:var(--uo-spacing-3);flex:1;min-width:0;min-height:64px;padding:var(--uo-spacing-2) 0;background:transparent;border:0;color:var(--uo-color-text-primary)}
.uo-follow-list .userpic{width:40px;height:40px;flex:none}
.uo-follow-list .uo-follow-person>span{min-width:0;overflow-wrap:anywhere}
.uo-follow-list strong,.uo-follow-list small{display:block}
.uo-follow-list small{font-size:12px;color:var(--uo-color-text-secondary)}
</style>
